import React, {useEffect, useState} from 'react';
import {useFormContext, Controller} from 'react-hook-form';
import PropTypes from 'prop-types';
import Select from 'react-select';
import './SelectList.scss'
import {t} from 'react-switch-lang';
import {Tooltip} from "antd";

const SelectList = ({
                      name,
                      options,
                      className,
                      isDisabled,
                      selectedItem,
                      placeholder,
                      defaultValue = null,
                      selected,
                      style,
                        hasTooltipDescription,
                      onLoadMore,
                      hasMore,
                      isLoading,
                      onSearch,
                      ...rest
                    }) => {
  if (!useFormContext())
    throw new Error('Smart component must be in "Form" wrapper component!');
  if (!name) {
    throw new Error('"name" field is required for SelectList component');
  }
  if (!options) {
    throw new Error(
      '"options" field is required for SelectList component',
    );
  }

  const {control, errors} = useFormContext();
  const handleMenuScrollToBottom = () => {
    if (onLoadMore && hasMore && !isLoading) {
      onLoadMore();
    }
  };
  const handleInputChange = (inputValue, actionMeta) => {
    if (actionMeta.action === 'input-change' && onSearch) {
      onSearch(inputValue);
    }
    return inputValue;
  };
  return (
    <>
      <Controller
        control={control}
        name={name}
        as={Select}
        options={options}
        noOptionsMessage={() => t('common.noData')}
        loadingMessage={() => t("message.loading")}
        className={`${className} ${errors[name] && ' error-field'}`}
        components={{IndicatorSeparator: () => null}}
        isClearable={true}
        isDisabled={isDisabled}
        isSearchable={true}
        placeholder={placeholder}
        defaultValue={selected ? selected : defaultValue}
        styles={style}
        onMenuScrollToBottom={handleMenuScrollToBottom}
        isLoading={isLoading}
        onInputChange={handleInputChange}
        {...rest}
      />
      {errors[name] && (
        <span className="error-message">{errors[name].message}</span>
      )}
    </>
  );
};

export default SelectList;

SelectList.propTypes = {
  name: PropTypes.string.isRequired,
  options: PropTypes.array,
};